import path from 'node:path'

export function snapshotTargetPath(cwd: string, filePath: string): string {
  return path.join(cwd, ...filePath.split('/'))
}
